import { valueStrings } from "constants/constantStrings";
import { DATE_FORMAT_SMALL, TIME_FORMAT } from "constants/globalConstants";

export const MAX_YEARS_IN_PICKER = 5;
export const TIME_INTERVAL = 15;

export const DatePickerConfig = {
  dateFormat: DATE_FORMAT_SMALL,
  showYearDropdown: true,
  showMonthDropdown: true,
  yearDropdownItemNumber: MAX_YEARS_IN_PICKER,
  isClearable: true,
  showPopperArrow: false,
  popperPlacement: "bottom-start",
  placeholderText: valueStrings.dateFormat
};

export const TimePickerConfig = {
  dateFormat: valueStrings.timeFormat,
  timeFormat: TIME_FORMAT,
  placeholderText: valueStrings.timeFormat,
  showTimeSelectOnly: true,
  timeIntervals: TIME_INTERVAL,
  showTimeSelect: true,
  timeCaption: valueStrings.time,
  popperPlacement: "bottom-end",
  isClearable: true,
  showPopperArrow: false,
  title: valueStrings.time
};
